import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seo from './seoConfig.json';

// Public pages get their own title/description/canonical; everything else
// (dashboard, exams, games, admin console) is kept out of search results.
// The same config is baked into static HTML at build time by
// scripts/prerender-seo.js so crawlers without JS see the right tags too.

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.rel = 'canonical';
    document.head.appendChild(el);
  }
  el.href = href;
};

const normalizePath = (pathname) => (pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname);

const Seo = ({ noindex = false }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = normalizePath(pathname);
    const page = !noindex && seo.routes[path];

    if (!page) {
      document.title = seo.privateRoute.title;
      setMeta('name', 'robots', seo.privateRoute.robots);
      return;
    }

    const url = `${seo.siteUrl}${path === '/' ? '/' : path}`;
    document.title = page.title;
    setMeta('name', 'description', page.description);
    setMeta('name', 'robots', 'index, follow, max-image-preview:large');
    setCanonical(url);
    setMeta('property', 'og:title', page.title);
    setMeta('property', 'og:description', page.description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', page.title);
    setMeta('name', 'twitter:description', page.description);
  }, [pathname, noindex]);

  return null;
};

export default Seo;
